<template>
    <div>
        <h1 style="text-align: center;">Jigsaw Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntImg">
                <h2>Image</h2>
                <div><img :src="img.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="imgsel" v-on:change="changeImage()" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <hr>
            <div class="questions">
                <div class="question" v-for="(ques, i) in  questions" :key="'question' + i" :ref="'cntQues-' + i">
                    <select v-model="ques.type" @change="changeType(i, $event.target.value)">
                        <option value="">Select question type...</option>
                        <option value="hint">Hint</option>
                        <option value="mcq">Multiple Choice Question</option>
                        <option value="ftb">Fill in the blank</option>
                        <option value="tf">True/False</option>
                    </select>
                    <div v-if="ques.type == 'hint'">
                        <textarea v-model="ques.data.q"></textarea>
                    </div>
                    <div v-if="ques.type == 'mcq'">
                        <textarea v-model="ques.data.q"></textarea>
                        <div v-for="(ans, ai) in ques.data.a" :key="'mcq-ans-' + ai">
                            &nbsp;<input type="radio" :value="ai" v-model="ques.data.i">&nbsp;&nbsp;
                            <input type="text" :placeholder="'Answer #' + (ai+1)" v-model="ques.data.a[ai]">
                        </div>
                    </div>
                    <div v-if="ques.type == 'ftb'">
                        <textarea :ref="'ftbq-' + i" v-model="ques.data.q" placeholder="Please use '~~' for fill in the blanks. e.g. 'this is a ~~blank~~'"></textarea>
                        <div style="background: #242424; color: #efefef;" v-html="ftbProcess(i)"></div>
                    </div>
                    <div v-if="ques.type == 'tf'">
                        <textarea v-model="ques.data.q"></textarea>
                        &nbsp;<input type="radio" id="true" value="true" v-model="ques.data.a">&nbsp;&nbsp;<label for="true">True</label><br>
                        &nbsp;<input type="radio" id="false" value="false" v-model="ques.data.a">&nbsp;&nbsp;<label for="false">False</label>
                    </div>
                </div>
            </div>
            <hr>
            <div>
                <h2>Audio Files on Completion</h2>
                <div v-for="(audio, i) in audioFiles" :key="'audio-' + i" :ref="'cntAudio-' + i">
                    <input type="text" v-model="audio.data.t" placeholder="Audio Title">
                    <input type="button" value="Browse mp3 Files..." @click="$refs['audiofile-' + i][0].click()">
                    <input type="file" :ref="'audiofile-' + i" accept="audio/mpeg" v-on:change="changeAudio(audio, $event.target.files[0])" style="display:none;">
                    <input type="text" :value="audio.upload.file ? audio.upload.file.name : 'No File Chosen'" style="width: 50%" disabled>
                    <button style="background: red; color: white;" @click="deleteAudio(i)">Delete</button>
                    <hr>
                </div>
                <button @click="addNewAudio()" class="submit-btn">Add New Audio File</button>
            </div>
            <div>
                <button @click="submitThis()" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
{/*
[
    {
      "t": "hint",
      "q": "Hint 1. This is a hint or information of some sort, this can contain a bit of complex info regarding different things that could be related to the iamge in the puzzle.",
      "a": "OK"
    },
    {
      "t": "mcq",
      "q": "Q1. What is the correct answer?",
      "a": [
        "Wrong Answer",
        "Wrong Answer",
        "Correct Answer",
        "Wrong Answer"
      ],
      "i": 2
    },
    {
      "t": "ftb",
      "q": "F2. French fries are made of ||--FTB--||, and you eat them with ||--FTB--||",
      "a": [
        "potatoes",
        "sauce"
      ]
    },
    {
      "t": "tf",
      "q": "TF2. This statement is false",
      "a": 0
    }
]

    "completedMusicFiles": [
        {
        "t": "Audio track #1",
        "s": "https://s3.amazonaws.com/app.thirdandlong.tv/testassets/Neshcomringtone.mp3"
        },
        {
        "t": "Another audio track",
        "s": "https://s3.amazonaws.com/app.thirdandlong.tv/testassets/Neshcomskypetone.mp3"
        }
    ],
]
*/}
export default {
    name: "JigsawAddEditComponent",
    props: ['ID'],
    data: () => ({
        isLoading: true,
        title: "",
        img: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        questions: [],
        audioFiles: [],
        functions: undefined
    }),
    mounted: function() {
        this.functions = new Functions();
        // console.log(this.isLoading);
        if(this.ID){
            console.log("Editing", this.ID);
            this.functions.getComponent(this.ID, (componentData) => {
                console.log(componentData);
                this.title = componentData.title;
                this.desc = componentData.data.imgdesc;
                // this.$refs.quillEditor.quill.setContents(this.desc);
                this.id = componentData.contentId;
                this.img.publicUrl = componentData.data.img;
                this.img.data = componentData.data.img;
                this.thumbnail.publicUrl = componentData.rdsDat[0].Thumbnail;
                this.setupData(componentData.data);
                console.log(1);
                this.functions.getSignedUrl("ttedu-public-uploads", this.img.publicUrl.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg", "putObject", (dat) => {
                    console.log(2, componentData.rdsDat[0].Thumbnail);
                    this.img.uploadUrl = dat.signedUrl;
                    this.functions.getSignedUrl("ttedu-static", componentData.rdsDat[0].Thumbnail, "image/jpeg", "getObject", (thumbBuff) => {
                        console.log(3, thumbBuff);
                        this.thumbnail.data = thumbBuff.signedUrl;
                        this.functions.getSignedUrl("ttedu-static", componentData.rdsDat[0].Thumbnail, "image/jpeg", "putObject", (thumbBuff1) => {
                            console.log(4);
                            this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                            this.isLoading = false;
                        });
                    });
                });
            });
        }else{
            console.log("Creating New");
            
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.functions.getImageURL((dat) => {
                    this.img.publicUrl = dat.key;
                    this.img.uploadUrl = dat.signedUrl;
                    this.isLoading = false;
                }, err => console.error(err));
            },(err) => {
                console.error(err);
            });

            for(let i = 0; i < 16; i++) this.questions.push({
                type: "",
                data: undefined
            });
        }
    },
    methods: {
        submitThis: function(){
            this.isLoading = true;
            if(this.ID){
                if(this.verification(true)){
                    console.log("EDITING");
                    let componentData = this.generateComponentData();
                    console.log("FINISHED DATA:", componentData);
                    if(this.img.file == undefined){
                        this.uploadAudios(0, componentData);
                    }else{
                        this.functions.upload(this.img.uploadUrl, this.img.file, (data) => {
                            this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                                this.uploadAudios(0, componentData);
                            });
                        });
                    }
                }else{
                    this.isLoading = false;
                }
            }else{
                if(this.verification(false)){
                    console.log("CREATE NEW");
                    let componentData = this.generateComponentData();
                    console.log("FINISHED DATA:", componentData);
                    this.functions.upload(this.img.uploadUrl, this.img.file, (data) => {
                        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                            this.uploadAudios(0, componentData);
                        });
                    });
                }else{
                    this.isLoading = false;
                }
            }
        },
        uploadAudios: function(i, componentData){
            if(i < this.audioFiles.length){
                //upload the file
                if(this.audioFiles[i].upload.file == undefined){
                    this.uploadAudios(i + 1, componentData);
                }else{
                    this.functions.uploadAudio(this.audioFiles[i].upload.uploadUrl, this.audioFiles[i].upload.file, (data) => {
                        this.uploadAudios(i + 1, componentData);
                    });
                }
            }else{
                if(this.ID){
                    this.functions.updateComponent(this.ID, componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/jigsaw");
                    });
                }else{
                    this.functions.addComponent(componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/jigsaw");
                    });
                }
                
            }
        },
        generateComponentData: function(){
            let componentData = {
                ContentType: "INTERACTIVE",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: "jigsaw",
                Data: {
                    img: this.img.publicUrl,
                    pageTitle: this.title,
                    questions: this.questions,
                    completedMusicFiles: this.audioFiles
                }
            };//component Data init
            let buff = [];
            componentData.Data.questions.forEach((q) => {
                if(q.type == "ftb"){
                    //fill in the blank
                    let temp = {
                        t: q.data.t,
                        q: "",
                        a: []
                    };
                    let arr = q.data.q.split("~~");
                    arr.forEach((a, _i) => {
                        if(_i % 2 == 0){
                            temp.q += a;
                        }else{
                            temp.a.push(a);
                            temp.q += "||--FTB--||";
                        }
                    });
                    buff.push(JSON.parse(JSON.stringify(temp)));
                }else if(q.type == "tf"){
                    buff.push(JSON.parse(JSON.stringify({
                        t: "tf",
                        q: q.data.q,
                        a: (q.data.a == "true") ? 1 : 0
                    })));
                }else{
                    buff.push(JSON.parse(JSON.stringify(q.data)));
                }
            });
            componentData.Data.questions = buff;
            buff = [];
            componentData.Data.completedMusicFiles.forEach(aud => {
                buff.push(aud.data);
            });
            componentData.Data.completedMusicFiles = buff;
            return componentData;
        },
        setupData: function(data){
            //setup questions
            data.questions.forEach(q => {
                switch(q.t){
                    case "ftb":
                        let ques = q.q.split("||--FTB--||");
                        let ans = q.a;
                        let result = [],
                        i, l = Math.min(ques.length, ans.length);
                        for (i = 0; i < l; i++) {
                            result.push(ques[i], "~~" + ans[i] + "~~");
                        }
                        result.push(...ques.slice(l), ...ans.slice(l));
                        this.questions.push({
                            type: q.t,
                            data:{
                                t: q.t,
                                q: result.join(""),
                                a:[]
                            }
                        });
                        break;
                    case "tf":
                        this.questions.push({
                            type: q.t,
                            data: {
                                t: q.t,
                                q: q.q,
                                a: (q.a == 1) ? "true" : "false"
                            }
                        });
                        break;
                    default:
                        this.questions.push({
                            type: q.t,
                            data: q
                        });
                }
            });
            //setup audios
            data.completedMusicFiles.forEach(audio => {
                let key = audio.s.replace("https://ttedu-public-uploads.s3.amazonaws.com/", "");
                this.functions.getSignedUrl("ttedu-public-uploads", key, "audio/mpeg", "putObject", (data) => {
                    this.audioFiles.push({
                        upload: {
                            file: undefined,
                            uploadUrl: data.signedUrl
                        },
                        data: {
                            t: audio.t,
                            s: audio.s
                        }
                    });
                });
            });
        },
        verification: function(isEditing){
            let hasErrors = false;

            if(this.title.trim() == ""){
                this.$refs.cntTitle.classList.add("has-error");
                hasErrors = true;
            }else this.$refs.cntTitle.classList.remove("has-error");

            if(!isEditing){
                if(this.img.file == undefined){
                    this.$refs.cntImg.classList.add("has-error");
                    hasErrors = true;
                }else this.$refs.cntImg.classList.remove("has-error");
                this.audioFiles.forEach((a,i) => {
                    if(a.upload.file == undefined || a.data.t.trim() == ""){
                        this.$refs['cntAudio-' + i][0].classList.add("has-error");
                        hasErrors = true;
                    }else this.$refs['cntAudio-' + i][0].classList.remove("has-error");
                });
            }

            this.questions.forEach((q,i) => {
                let ref = this.$refs['cntQues-' + i][0];
                if(q.type == ""){
                    hasErrors = true;
                    ref.classList.add("has-error");
                }else{
                    if(q.data.q.trim() == ""){
                        hasErrors = true;
                        ref.classList.add("has-error");
                    }else{
                        switch(q.data.t){
                            case "mcq":
                                if(q.data.a[0].trim() == "" || q.data.a[1].trim() == "" || q.data.a[2].trim() == "" || q.data.a[3].trim() == ""){
                                    ref.classList.add("has-error");
                                    hasErrors = true;
                                }else{
                                    ref.classList.remove("has-error");
                                }
                                break;
                            case "ftb":
                                if(q.data.q.split("~~").length <= 1){
                                    ref.classList.add("has-error");
                                    hasErrors = true;
                                    alert("Fill in blank has to have atleast 1 blank.");
                                }else{
                                    ref.classList.remove("has-error");
                                }
                                break;
                            default:
                                ref.classList.remove("has-error");
                                break;
                        }
                    }
                }
            });

            return !hasErrors;
        },
        deleteAudio: function(i){
            let c = confirm("Are you sure you want to delete Audio #" + (i+1));
            if(c){
                this.audioFiles.splice(i, 1);
            }
        },
        changeAudio: function(audio, file){
            // var file = this.$refs[ref][0].files[0];
            console.log(file);
            audio.upload.file = file;
        },
        addNewAudio: function(){
            this.isLoading = true;
            //getSignedUrl(bucket, key, contentType, operation, callback){
            let key = "audios/" + (new Date().getTime()) + "XX" + Math.floor(Math.random() * 10000000) + "XXaudio.mp3";
            this.functions.getSignedUrl("ttedu-public-uploads", key, "audio/mpeg", "putObject", (data) => {
                this.audioFiles.push({
                    upload: {
                        file: undefined,
                        uploadUrl: data.signedUrl
                    },
                    data: {
                        t: "",//Title
                        s: "https://ttedu-public-uploads.s3.amazonaws.com/" + key //public URL
                    }
                });
                this.isLoading = false;
            });
        },
        changeImage: function(){
            var reader = new FileReader();
            reader.onload = (e) => {
                this.img.data = e.target.result;
                this.thumbnail.data = e.target.result;
            }
            reader.readAsDataURL(this.$refs.imgsel.files[0]);
            this.img.file = this.$refs.imgsel.files[0];
            this.thumbnail.file = this.$refs.imgsel.files[0];
        },
        changeType: function(i, val){
            console.log(i, val);
            switch(val){
                case "hint":
                    this.questions[i].data = {
                        t: val,
                        q: "",
                        a: "OK"
                    };
                    break;
                case "mcq":
                    this.questions[i].data = {
                        t: val,
                        q: "",
                        a: ["", "", "", ""],
                        i: 0
                    };
                    break;
                case "ftb":
                    this.questions[i].data = {
                        t: val,
                        q: "",
                        a: []
                    };
                    break;
                case "tf":
                    this.questions[i].data = {
                        t: val,
                        q: "",
                        a: "true"
                    };
                    break;
                default:
                    this.questions[i].data = undefined;
                    break;
            }
        },
        ftbProcess: function(i){
            let str = "";
            let arr = this.questions[i].data.q.split('~~');
            arr.forEach((x,y) => {
                if(y % 2 == 0) str += x;
                else str += "<u>" + x.trim() + "</u>";
            });
            return str;
        }
    }
}
</script>


<style scoped>
textarea{
    width: 100%;
}
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    hr{
        margin-top: 1em;
        border: solid 2px white;
    }
    h2{
      color: black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
    .questions{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .question{
        flex: 25%;
        padding: 1.5em 0.5em;
        box-sizing: border-box;
        border: 1px solid white;
    }
</style>